import "./schemaStyle.scss";
import useStore from "../../hooks/useStore";
import { cn } from "../../utils";

export default function InfoTag({ name, mode = "object" }) {
  const pivotObject = useStore((state) => state.pivotObject);
  const data = useStore((state) => state.data);
  const d = data[pivotObject];
  return (
    <div className={cn("infotag-container", `infotag-${mode}`)}>
      <div className="object-tag">{name}</div>
      {/* {name === pivotObject && (
        <div className="info-structure-tag">{d.length}</div>
      )} */}
    </div>
  );
}
